import { SVGAttributes } from 'react'

// eslint-disable-next-line no-undef
interface IPlateSearchSVGProps extends SVGAttributes<HTMLOrSVGElement> {
  color?: string
  width?: number
  height?: number
}

export function PlateSearchSVG({
  color = 'var(--blue-800)',
  width = 48,
  height = 48,
  ...props
}: IPlateSearchSVGProps) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M107 4896 c-49 -18 -64 -32 -89 -80 -37 -73 -13 -153 62 -203 l33
-23 1807 0 1807 0 33 23 c48 32 72 69 77 119 7 58 -23 118 -74 149 l-38 24
-1790 2 c-1480 2 -1797 0 -1828 -11z"
        />
        <path
          d="M95 3826 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 25 -8
305 -10 874 -8 827 3 837 3 864 24 53 39 69 71 69 134 0 63 -16 95 -69 134
-27 21 -36 21 -874 23 -689 2 -853 0 -877 -11z"
        />
        <path
          d="M3060 3834 c-208 -27 -407 -101 -580 -217 -96 -64 -273 -241 -337
-337 -95 -142 -163 -302 -199 -470 -26 -119 -26 -381 0 -500 56 -259 167 -462
355 -651 185 -186 394 -300 651 -355 119 -26 381 -26 500 0 167 36 338 109
470 199 l65 45 450 -448 c487 -486 471 -472 562 -455 49 9 109 69 118 118 17
91 31 75 -455 562 l-448 450 44 65 c94 138 164 302 200 470 26 119 26 381 0
500 -55 257 -169 466 -355 651 -185 185 -380 293 -631 350 -83 19 -331 33
-410 23z m371 -343 c182 -47 320 -128 454 -265 127 -130 207 -274 252 -452 24
-95 24 -333 0 -428 -46 -185 -125 -324 -262 -461 -137 -137 -276 -216 -461
-262 -98 -24 -324 -24 -424 0 -364 88 -636 359 -727 723 -24 95 -24 333 0 428
46 182 128 328 261 462 158 157 305 231 556 278 59 11 277 -3 351 -23z"
        />
        <path
          d="M95 2706 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 25 -8
240 -10 659 -8 613 3 622 3 650 24 98 73 98 195 0 268 -28 21 -37 21 -660 23
-510 2 -638 0 -662 -11z"
        />
        <path
          d="M95 1586 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 25 -8
305 -10 874 -8 827 3 837 3 864 24 53 39 69 71 69 134 0 63 -16 95 -69 134
-27 21 -36 21 -874 23 -689 2 -853 0 -877 -11z"
        />
        <path
          d="M80 508 c-48 -33 -72 -70 -77 -120 -7 -58 23 -118 74 -149 l38 -24
1805 0 1805 0 38 24 c51 31 81 91 74 149 -5 50 -29 87 -77 120 l-33 22 -1807
0 -1807 0 -33 -22z"
        />
      </g>
    </svg>
  )
}
